import React, { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Container,
    Stack,
    Box,
    Snackbar,
    Alert,
    Typography,
    Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import ActionBar from '../components/ActionBar';
import AlertBar from '../components/AlertBar';
import AdminBreadcrumb from '../components/AdminBreadcrumb';
import LoadingSpinner from '../components/LoadingSpinner';
import AbstractBackground from '../components/AbstractBackground';
import StaticBackground from '../components/StaticBackground';
import actionBarConfig from '../config/actionBarConfig';
import promptBarConfig from '../config/promptBarConfig';
import EmptyStateTilesConfig from '../config/emptyStateTilesConfig';
import { sendMessage } from '../services/apiService';
import EmptyStateTiles from '../components/EmptyStateTiles';
import MessageRenderer from '../services/messageRenderer';
import PromptBarRibbon from '../components/PromptBarRibbon';
import Footer from '../components/Footer';
import {
    addMessage,
    clearMessages,
    selectChatContext,
} from '../reducers/messagesReducer';
import { setLoading } from '../reducers/loadingReducer';
import { showToast, hideToast } from '../reducers/uiReducer';
import {
    setShowTiles,
    setIsActiveChat,
    setSelectedTileId,
    clearSelectedTileId,
    addPromptItem,
    removePromptItem,
    updatePromptItem,
    clearPromptItems,
} from '../reducers/uiReducer';

import ProfileAchievements from '../components/ProfileAchievements';
import AdminUserInvite from '../components/AdminUserInvite';

import useResponsive from '../hooks/useResponsive';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    container: {
        height: '100vh',
        width: '100%',
        minWidth: '300px',
        maxWidth: '1000px',
        display: 'flex',
        flexDirection: 'column',
    },
    actionBar: {
        backgroundColor: '#e0e0e0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    contentArea: {
        flexGrow: 1,
        overflow: 'hidden',
        display: 'flex',
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
        background: `linear-gradient(to top, 
          rgba(255, 255, 255, 0.8),  
          rgba(0, 116, 211, 0.1)  
        )`,
        position: 'relative',
        overflowY: 'auto', // Add this line to enable vertical scrolling
    },
    AdminContainer: {
        display: 'flex',
        width: '100%',
        overflow: 'hidden',
        flexDirection: 'column',
        backgroundColor: 'white',
        padding: 16,
        margin: 16,
        borderRadius: 4,
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
        alignSelf: 'flex-start',
        background:
            'linear-gradient(180deg,rgb(255, 255, 255),rgb(228, 242, 251),rgb(228, 242, 251),rgb(242, 242, 242))', // Metallic gradient
    },
    footer: {
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    paper: {},
    loader: {},

    promptDockContainer: {
        backgroundColor: 'white',
        padding: '12px',
        borderTop: '2px solid rgb(255, 255, 255)',
        backgroundColor: 'rgb(233, 244, 255)',
    },
}));

const Roadmap = () => {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loading);
    const toast = useSelector((state) => state.ui.toast);
    const classes = useStyles();
    const containerRef = useRef(null);
    const { isTabletScreen, isMobileScreen } = useResponsive();

    const handleNewChat = () => {
        dispatch(clearMessages());
        dispatch(clearSelectedTileId());
        dispatch(setShowTiles(true));
        dispatch(setIsActiveChat(false));

        dispatch(clearPromptItems());
    };

    const memoizedBackground = useMemo(
        () => <AbstractBackground animate={loading} containerRef={containerRef} />,
        [loading],
    );

    const breadcrumbPath = [{ label: 'Releases' }];

    return (
        <Box className={classes.root}>
            <Box className={classes.container} ref={containerRef}>
                {memoizedBackground}

                <Box className={classes.actionBar}>
                    <ActionBar config={actionBarConfig} onNewChat={handleNewChat} />
                </Box>

                <Box className={classes.contentArea}>
                    <AlertBar
                        open={toast.open}
                        onClose={() => dispatch(hideToast())}
                        severity={toast.severity}
                        message={toast.message}
                    />
                    <Box className={classes.AdminContainer}>Roadmap</Box>
                </Box>
                <Footer className={classes.footer} />
            </Box>
        </Box>
    );
};

export default Roadmap;
